<template>
  <div class="services-product">
    <div class="title">{{ $t('serviceSupport.servicesProduct1.title') }}</div>
    <div class="content-item">
      <div class="content-title">{{ $t('serviceSupport.servicesProduct1.definition') }}</div>
      <div class="content-info">{{ $t('serviceSupport.servicesProduct1.definitionContent') }}</div>
    </div>
    <div class="content-item">
      <div class="content-title">{{ $t('serviceSupport.servicesProduct1.productIntro') }}</div>
      <div class="content-info">{{ $t('serviceSupport.servicesProduct1.productIntroContent') }}</div>
    </div>
    <div class="content-item">
      <div class="content-title">{{ $t('serviceSupport.servicesProduct1.performanceAdvantage') }}</div>
      <div class="content-advantage">
        <div class="advantage-item" 
          v-for="(item, index) in advantageList" 
          :key="index"
        >
          <img :src="item.iconUrl">
          <div class="advantage-item-title">{{ item.title }}</div>
          <div class="advantage-item-li" 
            v-for="(info, index) in item.content" 
            :key="index"
            :style="`padding-left: ${item.paddingLeft}px`"
          >
            <span></span>
            <div class="item-info">{{ info }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-item">
      <div class="content-title">{{ $t('serviceSupport.servicesProduct1.mainProductSystem') }}</div>
      <div class="content-table">
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="productType"
            :label="$t('serviceSupport.servicesProduct1.tableColumns.productType')"
            width="299">
          </el-table-column>
          <el-table-column
            prop="query"
            :label="$t('serviceSupport.servicesProduct1.tableColumns.keyParams')"
            width="450">
          </el-table-column>
          <el-table-column
            prop="applicableScenario"
            :label="$t('serviceSupport.servicesProduct1.tableColumns.applicableScenario')"
            width="450"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="content-item" style="padding-bottom: 0;">
      <div class="content-title">{{ $t('serviceSupport.servicesProduct1.applicationValue') }}</div>
      <div class="content-info">{{ $t('serviceSupport.servicesProduct1.applicationValueContent') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    advantageList () {
      return this.$t('serviceSupport.servicesProduct1.advantages').map((advantage, index) => ({
        title: advantage.title,
        iconUrl: [
          require('@/assets/images/serviceSupport/icon2.png'),
          require('@/assets/images/serviceSupport/icon3.png'),
          require('@/assets/images/serviceSupport/icon1.png')
        ][index],
        content: advantage.content,
        paddingLeft: [62, 84, 92][index]
      }))
    },
    tableData () {
      return this.$t('serviceSupport.servicesProduct1.tableData')
    }
  }
}
</script>

<style lang="scss" scoped>
.services-product {
  width: 1200px;
  margin: 0 auto;
  padding: 100px 0;
  .title {
    font-weight: 600;
    font-size: 40px;
    line-height: 56px;
    text-align: center;
    padding-bottom: 80px;
  }
  .content-item {
    padding-bottom: 80px;
    .content-title {
      font-weight: 500;
      font-size: 24px;
      line-height: 34px;
      padding-bottom: 24px;
    }
    .content-info {
      font-weight: 400;
      font-size: 18px;
      line-height: 32px;
      color: rgba(43, 50, 71, 0.7);
    }
  }
  .content-advantage {
    display: flex;
    justify-content: center;
    align-items: center;
    .advantage-item {
      width: 384px;
      height: 384px;
      background: rgb(248, 250, 253);
      margin: 0 12px;
      text-align: center;
      box-sizing: border-box;
      padding: 45px 0 68px;
      &:last-child {
        margin-right: 0;
      }
      &:first-child {
        margin-left: 0;
      }
      .advantage-item-title {
        font-weight: 700;
        font-size: 20px;
        line-height: 25px;
        padding-top: 40px;
        padding-bottom: 20px;
      }
      .advantage-item-li {
        display: flex;
        align-items: center;
        padding-left: 50px;
        span {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: rgba(43, 50, 71, 0.7);
          margin-right: 8px;
        }
        .item-info {
          font-weight: 400;
          font-size: 16px;
          line-height: 30px;
          color: rgba(43, 50, 71, 0.7);
        }
      }
    }
  }
  .content-table {
    ::v-deep .el-table__header th {
      color: rgb(34, 34, 34);
    }
    ::v-deep .el-table__body td {
      color: rgba(43, 50, 71, 0.7);
    }
  }
}
</style>